import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { CustomValidator } from 'src/app/services/validation';
import { AccountService } from '../account.service';
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js'
import { environment } from 'src/environments/environment.local';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordComponent } from '../change-password/change-password.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  isShow = false;
  userData: any;
  key = CryptoJS.enc.Utf8.parse("contractorPortal"); // 256-bit key (32 characters)
  salt = { "words": [130332099, 3412898925, 4080727054, 1733911705], "sigBytes": 16 };
  selectedBusiness: any;
  constructor(private fb: FormBuilder, private accountService: AccountService, private router: Router, public cookieService:CookieService, public snackbarService: SnackbarService, public dialog: MatDialog) {
    this.selectedBusiness = sessionStorage.getItem('Business');
    if (this.selectedBusiness) {

    } else {
      this.router.navigate(['/auth/login-selection']);
    }
  }

  ngOnInit(): void {
    this.buildLoginForm();
  }

  buildLoginForm() {
    let data = localStorage.getItem('userdata')
    let decryptedPassword;
    if (data) {

      this.userData = JSON.parse(CryptoJS.AES.decrypt(data, environment.encrypt_passcode).toString(CryptoJS.enc.Utf8))
      decryptedPassword = this.decryptMessageSalt(this.userData?.request?.password,this.userData?.request?.salt)
    }
    this.loginForm = this.fb.group({
      username: [this.userData?.request?.username, [Validators.required, CustomValidator.cannotContainSpace]],
      password: [decryptedPassword, Validators.required],
      remember:  [this.userData?.request?.remember || false]
    })
    if (this.cookieService.check('jwt-refresh')) {
      this.navigateToDashboard();
    }
  }

  // encryptMessage(message, key, salt) {
  //   const keySize = 512; // 256 bits
  //   const iterations = 1000;

  //   const encrypted = CryptoJS.AES.encrypt(message, key, {
  //     keySize: keySize / 16,
  //     iv: salt,
  //     mode: CryptoJS.mode.CBC,
  //     padding: CryptoJS.pad.Pkcs7,
  //     iterations: iterations
  //   });

  //   return encrypted.toString();
  // }

  decryptMessageSalt(ciphertext:any, key:any) {
    const keySize = 512; // 256 bits
    const iterations = 1000;
   
    const decrypted = CryptoJS.AES.decrypt(atob(ciphertext), key, {
      keySize: keySize / 16,
      //iv: salt,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iterations: iterations
    });
   
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  encryptSaltMessage(message:any, key:any) {
    const keySize = 512; // 256 bits
    const iterations = 1000;

    const encrypted = CryptoJS.AES.encrypt(message, key, {
      keySize: keySize / 16,
      //iv: salt,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iterations: iterations
    });

    return encrypted.toString();
  }

  // encode(str: string) {
  //   const ciphertext = this.encryptMessage(str, this.key, this.salt);
  //   return btoa(ciphertext);
  // }
  encodeSalt(str: string,key:string) {   
    const ciphertext = this.encryptSaltMessage(str, key);
    //return btoa(ciphertext);
    return btoa(ciphertext);
  }
  // decryptMessage(ciphertext, key, salt) {
  //   const keySize = 512; // 256 bits
  //   const iterations = 1000;
  //   const decrypted = CryptoJS.AES.decrypt(atob(ciphertext), key, {
  //     keySize: keySize / 16,
  //     iv: salt,
  //     mode: CryptoJS.mode.CBC,
  //     padding: CryptoJS.pad.Pkcs7,
  //     iterations: iterations
  //   });

  //   return decrypted.toString(CryptoJS.enc.Utf8);
  // }
  doLogin() {
    this.loginForm.markAsTouched();
    if (!this.loginForm.invalid) {

      let request = {
        ...this.loginForm.value
      }
      let requestRemember = {
        ...this.loginForm.value
      }
      let saltRequest = {
        username:this.loginForm.value.username
        
      }
      
      request['business'] = sessionStorage.getItem('Business');

      this.accountService.getAuthenticationSalt(saltRequest).subscribe((saltData:any) => {
        if (saltData['status'] == 200) {
          request.password = this.encodeSalt(this.loginForm.value.password,saltData['salt']);
          request.salt = saltData['salt'];
          this.accountService.getAuthentication(request).subscribe((data:any) => {
            if (data['status'] == 200 && data['is_first_time_login']) {
              this.openDialog()
            }
            else if (data['status'] == 200 && data['message'] == 'login successfully') {
              this.cookieService.set('jwt-refresh', data['token']);
              sessionStorage.setItem('countryCode',data?.country)
              //request.password = this.decryptMessage(request.password, this.key, this.salt);
              //let encodedPassword = request.password.split("-");
              //request.password = atob(encodedPassword[1]);

              let userValue = CryptoJS.AES.encrypt(JSON.stringify({ request }), environment.encrypt_passcode).toString();
              
              if (this.loginForm?.get('remember')?.value) {
                localStorage.setItem('userdata', userValue);
              } else if (localStorage.getItem('userdata')) {
                localStorage.removeItem('userdata')
              }
              this.navigateToDashboard();

            } else {
              this.openSnackbar(data['message']);
            }
          }, error => {
            let message = error.error || error.error[0];
            this.openSnackbar(message.error);
          })

        }


      }, error => {
        let message = error.error || error.error[0];
        this.openSnackbar(message.error);
      })

    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '38%',
      data: {
        username: this.loginForm?.get('username')?.value
      }
    });
    dialogRef.componentInstance.updateStatus.subscribe(data => {

    })
  }

  doGoogleSignIn() {
    this.accountService.googleSignIn()
  }
  navigateOnSignUp() {
    this.router.navigate(['/auth/signup'])
  }
  /**
* open toaster for showing message
*/
  openSnackbar(message: string) {
    this.snackbarService.open(message);
  }

  navigateToDashboard() {
    this.router.navigate(['/dashboard']);
  }
}
